export const SERVICE_TYPE = {
  MAKE_BED: 101,
  EXTRA_BED: 102,
  MORNING_CALL: 103,
  LATE_CHECK_OUT: 104,
  CHANGING_ROOM: 105,
  WIFI: 106,
  FRENCH: 201,
  ITALIAN: 202,
  PICK_UP: 301,
  TAXI: 302,
  STROLLER_RENTAL: 303,
  NEWSPAPER: 304,
  LOST_BAGGAGE: 305,
  CLEANING_OBJECTS: 401,
  LAUNDRY: 402,
  HOUSEKEEPING: 403,
  AMENITY: 404,
  TURNDOWN: 405,
  PARKING: 501,
  BAGGAGE_HANDLING: 502,
  BAGGAGE_DEPOSIT: 503,
  MESSAGE: 601,
  PHONE_CALL: 602,
  PROGRESS: 603,
  ROOM_RENOVATION: 604,
};

export const SERVICE_VALUE = {
  [SERVICE_TYPE.MAKE_BED]: 'service.serviceCounter.makeBed',
  [SERVICE_TYPE.EXTRA_BED]: 'service.serviceCounter.extraBed',
  [SERVICE_TYPE.MORNING_CALL]: 'service.serviceCounter.morningCall',
  [SERVICE_TYPE.LATE_CHECK_OUT]: 'service.serviceCounter.lateCheckOut',
  [SERVICE_TYPE.CHANGING_ROOM]: 'service.serviceCounter.changingRoom',
  [SERVICE_TYPE.WIFI]: 'service.serviceCounter.wifi',
  [SERVICE_TYPE.FRENCH]: 'service.restaurant.french',
  [SERVICE_TYPE.ITALIAN]: 'service.restaurant.italian',
  [SERVICE_TYPE.PICK_UP]: 'service.conciergeService.pickUp',
  [SERVICE_TYPE.TAXI]: 'service.conciergeService.taxi',
  [SERVICE_TYPE.STROLLER_RENTAL]: 'service.conciergeService.strollerRental',
  [SERVICE_TYPE.NEWSPAPER]: 'service.conciergeService.newspaper',
  [SERVICE_TYPE.LOST_BAGGAGE]: 'service.conciergeService.lostBaggage',
  [SERVICE_TYPE.CLEANING_OBJECTS]: 'service.housekeeper.cleaningObjects',
  [SERVICE_TYPE.LAUNDRY]: 'service.housekeeper.laundry',
  [SERVICE_TYPE.HOUSEKEEPING]: 'service.housekeeper.housekeeping',
  [SERVICE_TYPE.AMENITY]: 'service.housekeeper.amenity',
  [SERVICE_TYPE.TURNDOWN]: 'service.housekeeper.turndown',
  [SERVICE_TYPE.PARKING]: 'service.parkingAndBaggage.parking',
  [SERVICE_TYPE.BAGGAGE_HANDLING]: 'service.parkingAndBaggage.baggageHandling',
  [SERVICE_TYPE.BAGGAGE_DEPOSIT]: 'service.parkingAndBaggage.baggageDeposit',
  [SERVICE_TYPE.MESSAGE]: 'service.contactUs.message',
  [SERVICE_TYPE.PHONE_CALL]: 'service.contactUs.phoneCall',
  [SERVICE_TYPE.PROGRESS]: 'service.contactUs.progress',
  [SERVICE_TYPE.ROOM_RENOVATION]: 'service.contactUs.roomRenovation',
};

export const RESOURCE_STATE = {
  IDLE: 'IDLE',
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
  REJECTED: 'REJECTED',
};

export const PROCESS_STATUS = {
  PENDING: 0,
  PROCESSING: 1,
  FINISHED: 2,
};
export const PROCESS_VALUE = {
  [PROCESS_STATUS.PENDING]: 'pending',
  [PROCESS_STATUS.PROCESSING]: 'processing',
  [PROCESS_STATUS.FINISHED]: 'finished',
};
export const PROCESS_COLOR = {
  [PROCESS_STATUS.PENDING]: 'red',
  [PROCESS_STATUS.PROCESSING]: 'blue',
  [PROCESS_STATUS.FINISHED]: 'green',
};

export const REGISTER_MAIL_TEMPLATE =
  '<!DOCTYPE html><html lang="zh_TW"><head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"></head><body> <div style="background-color: #b48e79; width: 100%; padding-top: 1rem;"> <div style="background-color: #87523e; width: 100%; text-align: center;"> <img src="https://admin.hotelnews.tw/FileUploads/hotel-1049/210616152630193.png" alt="Kloud Hotel Logo" style="margin: 3rem; max-width: 40%;"/> </div><div style="padding: 1rem 3rem;"> <p style="color: white;">Dear {{name}}，您好！</p><p style="color: white;"> 歡迎您加入浮雲客栈會員浮雲客位於台中逢甲夜市旁，提供給品味時尚、精打細算希望物超所值的個人、朋友、情侶、家庭的自由行旅客與企業出差者。一個注重務實、方便、環保的智慧星級旅館，在這裡，是您熟悉的第二個家。 </p></div></div><div style="padding: 2rem;"> <div style="border: #87523e 1px solid; border-radius: 5px; padding: 1rem;"> <div style="color: #87523e; text-align: center; display: inline-block; width: 15rem;"> <p>會員資訊</p><p>Information</p></div><div style="border-left: #87523e 1px solid; padding-left: 2rem; display: inline-block;"> <p>會員(Name)：{{name}}</p><p>電子信箱(E-mail)：{{email}}</p></div><div style="width:100%; border-bottom: #87523e 1px dashed; margin: 1rem 0;"> </div><div style="color: #87523e; text-align: center; display: inline-block; width: 15rem;"> <p>浮雲客棧 Kloud Hotel</p><p>Hotel Information</p></div><div style="border-left: #87523e 1px solid; padding-left: 2rem; display: inline-block;"> <p>旅店電話(Hotel Tel)：04-2706-5855</p><p>旅店信箱(Hotel E-mail)：KH@kloudhotel.com.tw</p><p>旅店地址(Hotel Address)：407台中市西屯區西安街277巷59號</p></div></div></div><div style="color: white; background-color: #b48e79; padding: 1rem; text-align: center;"> <p>此為系統自動通知信，請問直接回信！</p><p>Please Note: This message is automatically sent, please do not reply directly!</p></div></body></html>';
export const SHARE_TRADE_TEMPLATE =
  '<!DOCTYPE html><html lang="zh_TW"><head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"></head><body> <div style="background-color: #b48e79; width: 100%; padding-top: 1rem;"> <div style="background-color: #87523e; width: 100%; text-align: center;"> <img src="https://admin.hotelnews.tw/FileUploads/hotel-1049/210616152630193.png" alt="Kloud Hotel Logo" style="margin: 3rem; max-width: 40%;"/> </div></div><div style="padding: 2rem;"> <div style="border: #87523e 1px solid; border-radius: 5px; padding: 1rem;"> <div style="color: #87523e; text-align: center; display: inline-block; width: 15rem;"> 請點擊連結 <a href="{{sharedLink}}">匯入訂單資訊</a> </div></div></div><div style="color: white; background-color: #b48e79; padding: 1rem; text-align: center;"> <p>此為系統自動通知信，請問直接回信！</p><p>Please Note: This message is automatically sent, please do not reply directly!</p></div></body></html>';
